export function isChatActive(state) {
    return ['Started', 'Matched', 'Upcoming', 'Queued'].includes(state);
}